module.exports = __webpack_public_path__ + "index/img/icon_UpFileImg.21aa4d63.png";